// whitelabelAuthPaint — the branded paint for the design-system auth cards
// (signup, reset-password, accept-invite) on a white-label host
// (Nika 2026-10-14: "update login screen make it more beautiful for astio
// login" — login / signup / accept-invite / reset read as ONE family).
//
// `el.call('whitelabelAuthPaint', s)` → null off a branded host, or when the
// record carries no parseable accent (the platform primary then stands);
// else:
//   fill      the tenant accent — the primary button's fill
//   ink       the label ink on that fill: white or near-black, whichever has
//             the higher WCAG contrast on the accent (the same fallback rule
//             as WhitelabelSignin.js onAccentFor)
//   backdrop  the soft accent light behind the card
//
// Everything comes from the org's branding record (root.whitelabelBrand); no
// tenant is named here. Self-contained (FA204 / FA001): no import and no
// module-scope helper — every step lives inside the function body.
export const whitelabelAuthPaint = function (s) {
  const st = s && s.root ? s : this && this.state
  const brand = st && st.root && st.root.whitelabelBrand
  const accent = brand && typeof brand.accent === 'string' ? brand.accent.trim() : ''
  if (!accent) return null
  const rgbOf = (c) => {
    const hex = c.charAt(0) === '#' ? c.slice(1) : null
    if (hex && (hex.length === 3 || hex.length === 6)) {
      const f = hex.length === 3 ? hex.replace(/./g, (ch) => ch + ch) : hex
      const n = parseInt(f, 16)
      if (!Number.isNaN(n)) return [(n >> 16) & 255, (n >> 8) & 255, n & 255]
    }
    const m = c.match(/rgba?\(\s*([0-9.]+)[,\s]+([0-9.]+)[,\s]+([0-9.]+)/i)
    return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null
  }
  const lum = (rgb) => {
    const ch = rgb.map((v) => {
      const x = v / 255
      return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4)
    })
    return 0.2126 * ch[0] + 0.7152 * ch[1] + 0.0722 * ch[2]
  }
  const rgb = rgbOf(accent)
  if (!rgb) return null
  const la = lum(rgb)
  const onWhite = (1 + 0.05) / (la + 0.05)
  const onDark = (la + 0.05) / (lum([17, 24, 32]) + 0.05)
  return {
    fill: accent,
    ink: onWhite >= onDark ? '#FFFFFF' : '#111820',
    backdrop:
      'radial-gradient(120% 70% at 50% -10%, color-mix(in srgb, ' +
      accent +
      ' 18%, transparent), transparent 70%)'
  }
}
